import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { isEmpty } from 'lodash';
import { BasicButton } from '@payer-admin-ui/components-v2/src/buttons/BasicButton';
import { IconType } from '@payer-admin-ui/components-v2/src/icons/BasicIcon';
import { PayerError } from '../utils/errors';
import { PayerErrorDialog } from '../Error/ErrorDialog';

export type CardPageProps = {
  error: PayerError | null;
  resetError: () => void;
  children: ReactNode;
  resetButtonProps?: {
    onReset: () => void;
    resetText: string;
  };
  submitButtonProps?: {
    submitStateIsFetching: boolean;
    submitStateSuccess: boolean | undefined;
    submitText: string;
    onSubmit: () => void;
  };
};

const cardPageSx = {
  animationName: 'fadeIn',
  animationDuration: '1s',
};

export const CardPage = ({ error, resetError, children, resetButtonProps, submitButtonProps }: CardPageProps) => {
  const { onReset, resetText } = resetButtonProps ?? {};

  return (
    <Box sx={cardPageSx}>
      <PayerErrorDialog error={error} onClose={resetError} />
      <Row>
        <Col xs="12">{children}</Col>
      </Row>
      {!isEmpty(resetButtonProps) && !isEmpty(submitButtonProps) && (
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <Row>
                  <Col xs className="text-right">
                    <BasicButton size="large" startIcon={IconType.CLEAR} onClick={onReset}>
                      {resetText}
                    </BasicButton>
                  </Col>
                  <Col xs="auto">
                    <BasicButton
                      color="primary"
                      size="large"
                      variant="contained"
                      startIcon={IconType.CHECK}
                      loading={submitButtonProps.submitStateIsFetching}
                      disabled={submitButtonProps.submitStateIsFetching || submitButtonProps.submitStateSuccess}
                      onClick={submitButtonProps.onSubmit}
                    >
                      {submitButtonProps.submitText}
                    </BasicButton>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Box>
  );
};
